import { render } from "./BList.vue?vue&type=template&id=0859c04a"
import script from "./BList.vue?vue&type=script&lang=js"
export * from "./BList.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__